import { useLazyQuery, useMutation } from "@apollo/client/react";
import { gql } from "@apollo/client";
import toast from "react-hot-toast";
import { AuthorizationCheckRequired, eventBus } from "@/state";

export interface Address {
    city:string,
    state:string,
    full_address:string,
    created_ts:string,
    id:string,
    latitude: number,
    line1:string,
    line2:string,
    longitude:number,
    zip:string
}


var queryGetAddress = gql`
  query address($addressId: UUID!) {
    address(addressId: $addressId) {
     id
     full_address
     city
     state
     street
     zip
     latitude
     longitude
    }
  }
`;


var mutationCreateAddress = gql`
  mutation addressCreate($line1: String!, $line2: String, $city: String!, $state: String!, $zip: String!) {
    addressCreate(addressLine1: $line1, addressLine2: $line2, city:$city, state:$state, zip:$zip) {
     id
     full_address
     city
     state
     street
     zip
     latitude
     longitude
    }
  }
`;



var mutationValidateAddress = gql`
  mutation addressValidate($address: String!) {
    addressValidate(address: $address) {
     id
     line1
     line2
     city
     state
     full_address
     zip
     latitude
     longitude
    }
  }
`;




export function useAddressActions() {

    const [apiGetAddress] = useLazyQuery(queryGetAddress);
    const [apiCreateAddress] = useMutation(mutationCreateAddress);
    const [apiValidateAddress] = useMutation(mutationValidateAddress);



    function ValidateAddress(address: String) {

        return new Promise(async (resolve, reject) => {
            apiValidateAddress( {variables: address} )
            .then((result: any) => result?.data?.addressValidate)
            .then((result) => resolve(result))
            .catch((err) => {
                let data =  JSON.parse(JSON.stringify(err))
                if(data?.message?.includes("user is not authorized"))
                {
                    eventBus.next({type: AuthorizationCheckRequired})
                }

                toast.error("Api Error, Unable to validate address");
                reject(err);
            })
        })
    }


    
    function CreateAddress(address: Address) {

        return new Promise(async (resolve, reject) => {
            apiCreateAddress( {variables: address} )
            .then((result: any) => result?.data?.addressCreate)
            .then((result) => resolve(result))
            .catch((err) => {
                let data =  JSON.parse(JSON.stringify(err))
                if(data?.message?.includes("user is not authorized"))
                {
                    eventBus.next({type: AuthorizationCheckRequired})
                }

                toast.error("Api Error, Unable to create address");
                reject(err);
            })
        })
    }

    

    function GetAddress(addressId: string) {

        return new Promise(async (resolve, reject) => {
            apiGetAddress(
                {variables: {
                    addressId,
                }}
            )
            .then((result: any) => result?.data?.address)
            .then((result) => resolve(result))
            .catch((err) => {
                let data =  JSON.parse(JSON.stringify(err))
                if(data?.message?.includes("user is not authorized"))
                {
                    eventBus.next({type: AuthorizationCheckRequired})
                }

                toast.error("Api Error, Unable to get address");
                reject(err);
            })
        })
    }

    
    return {
        GetAddress,
        CreateAddress,
        ValidateAddress
        
    };
}




